export default "__VITE_ASSET__Dgym9ntb__"